import React, { lazy, Suspense } from 'react';
import { FieldError } from './OnsiteFormPrimitives';

const CountryCodeSelector = lazy(() => import('./CountryCodeSelector'));

// Dial code selector + number input + error message, used by both onsite phone fields.
const OnsitePhoneField = ({
  name, placeholder, dial, number, error, onDialChange, onNumberChange, onBlur,
}) => (
  <>
    <div
      style={{
        display: 'flex', alignItems: 'stretch',
        border: '2px solid rgba(92,69,24,0.2)', borderRadius: 10,
        background: '#fffef9', overflow: 'visible',
        transition: 'border-color 0.15s, box-shadow 0.15s',
      }}
      onFocus={e => { e.currentTarget.style.borderColor = '#a67c2c'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(166,124,44,0.22)'; }}
      onBlur={e => { if (!e.currentTarget.contains(e.relatedTarget)) { e.currentTarget.style.borderColor = 'rgba(92,69,24,0.2)'; e.currentTarget.style.boxShadow = 'none'; } }}
    >
      <Suspense fallback={<div style={{ width: 90, flexShrink: 0 }} />}>
        <CountryCodeSelector value={dial} onChange={onDialChange} merged />
      </Suspense>
      <div style={{ width: 1, background: 'rgba(92,69,24,0.15)', alignSelf: 'stretch', flexShrink: 0 }} />
      <input
        name={name}
        value={number}
        onChange={(e) => onNumberChange(e.target.value.replace(/[^\d()\- ]/g, ''))}
        onBlur={onBlur}
        placeholder={placeholder}
        inputMode="numeric"
        style={{
          flex: 1, border: 'none', outline: 'none', background: 'transparent',
          padding: '12px 14px', fontSize: 14, fontWeight: 500,
          color: '#1e1a14', fontFamily: '"Poppins", sans-serif', minWidth: 0,
        }}
      />
    </div>
    {error && <FieldError>{error}</FieldError>}
  </>
);

export default OnsitePhoneField;
